import { Suspense, useMemo } from 'react';
import { Link } from 'react-router-dom';
import AnimatedFadeInComponent from '@/components/AnimatedFadeInComponent';
import { useHome } from '../../hooks/useHome';
import { useKeyDates } from '../../hooks/useKeyDates';
import { KeyDatesSectionSkeleton } from './KeyDatesSectionSkeleton';
import Button from '@/components/Button';
import { KeyDateCard } from '@/pages/key-dates/shared/components/key-date-card';

const KeyDatesSectionComponent = () => {
  const { homePage } = useHome();
  const { keyDates, keyDatePage } = useKeyDates(6);

  const keyDatesSection = useMemo(() => homePage.homePage?.keyDatesSection, [homePage]);

  if (keyDates.length === 0) {
    return null;
  }

  return (
    <AnimatedFadeInComponent fromBottom>
      <div>
        <div className="mb-sh-15 flex items-center gap-4">
          <img src={keyDatesSection?.icon?.url} alt="Icon" className="size-6" />
          <h2 className="font-haffer text-sh-28-32 font-bold">{keyDatesSection?.title || 'Key dates'}</h2>
        </div>
        {keyDatesSection?.description && (
          <p className="mb-sh-30 font-haffer text-sh-16-24 text-dark-grey">{keyDatesSection.description}</p>
        )}

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {keyDates.map((keyDate) => (
            <KeyDateCard key={keyDate.documentId} keyDate={keyDate} page={keyDatePage} />
          ))}
        </div>

        <Link to="/key-dates">
          <Button theme="solid" className="mt-sh-30 w-full md:w-auto">
            {keyDatesSection?.viewAllKeyDatesLabel || 'Full calendar'}
          </Button>
        </Link>
      </div>
    </AnimatedFadeInComponent>
  );
};

export const KeyDatesSection = () => {
  return (
    <Suspense fallback={<KeyDatesSectionSkeleton />}>
      <KeyDatesSectionComponent />
    </Suspense>
  );
};
